import { CRM_API_URL } from "../Config/index.js";
import { getAuthTokenPayload } from "../Utils/index.js";

// Helper function to get current clientId from the JWT auth token
const getClientId = () => {
  return getAuthTokenPayload()?.clientId ?? null;
};

// Helper function to get auth token from localStorage
const getAuthToken = () => {
  return localStorage.getItem("authToken");
};

// Add this new method for lead management
export const createNewLead = async (leadData) => {
  try {
    const clientId = getClientId();
    const token = getAuthToken();
    
    if (!clientId) {
      return {
        success: false,
        error: "Client ID not found. Please log in again."
      };
    }

    const response = await fetch(`${CRM_API_URL}/manage-leads/newLead`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `${token}` } : {}),
      },
      body: JSON.stringify({
        ...leadData,
        clientId: clientId
      })
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return {
      success: true,
      data: data
    };
  } catch (error) {
    console.error('Error creating new lead:', error);
    return {
      success: false,
      error: error.message
    };
  }
};
